import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * Deep link: /perfil/senha-transacional → perfil with transactional password modal open.
 */
export const TransactionalPassword = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace("/perfil", { openTransactionalPassword: true });
  }, [history]);

  return null;
};

export default TransactionalPassword;
